/**
 * assets/klantvijvers-cta.js
 * Gedrag van sections/klantvijvers-cta.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

/* Data uit het JSON-eiland #kvcta-config hierboven. Zie ARCHITECTURE.md sectie 11. */
var KVCTA = { galerij: null, endpoint: null };
try {
  var _el_KVCTA = document.getElementById('kvcta-config');
  if (_el_KVCTA) KVCTA = Object.assign(KVCTA, JSON.parse(_el_KVCTA.textContent) || {});
} catch (_e) {}

        (function () {
          var PREFIX = '[klantvijvers-cta]';
          var host = document.querySelector('[data-kvcta-thumbs]');
          if (!host) return;
          var galerij = KVCTA.galerij;
          var endpoint = KVCTA.endpoint;

          function toonMelding(reden, detail) {
            if (window.console && console.error) {
              console.error(PREFIX + ' thumbnails niet geladen: ' + reden, detail || '');
            }
            var p = document.createElement('p');
            p.className = 'kvcta-thumbs-melding';
            p.appendChild(document.createTextNode('De klantvijvers laden nu even niet. '));
            var a = document.createElement('a');
            a.href = galerij;
            a.textContent = 'Bekijk de klantvijvers';
            p.appendChild(a);
            host.innerHTML = '';
            host.appendChild(p);
            host.setAttribute('data-fout', '');
            host.setAttribute('data-shown', '');
          }

          if (!window.fetch) { toonMelding('deze browser ondersteunt fetch niet'); return; }

          try {
            fetch(endpoint + '?sort=nieuw&per_page=8', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                if (!r || !r.ok) {
                  throw new Error('status ' + (r ? r.status : 'geen antwoord') + ' op ' + endpoint);
                }
                return r.json();
              })
              .then(function (data) {
                var items = (data && data.items) || [];
                var met = items.filter(function (it) { return it && it.media && it.media[0]; }).slice(0, 4);
                if (!met.length) {
                  if (window.console && console.warn) {
                    console.warn(PREFIX + ' geen inzendingen met foto ontvangen, thumbnail-rij blijft verborgen');
                  }
                  return;
                }
                host.innerHTML = met.map(function (it) {
                  var url = String(it.media[0]).replace(/"/g, '&quot;');
                  var titel = String(it.titel || 'Klantvijver').replace(/"/g, '&quot;').replace(/</g, '&lt;');
                  return '<a class="kvcta-thumb" href="' + galerij + '" aria-label="Bekijk ' + titel + '"><img src="' + url + '" alt="' + titel + '" loading="lazy"></a>';
                }).join('');
                host.setAttribute('data-shown', '');
              })
              .catch(function (e) { toonMelding('ophalen mislukt', e); });
          } catch (e) {
            toonMelding('onverwachte fout bij het starten', e);
          }
        })();
